"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reservedIdentifierNames = void 0;
exports.reservedIdentifierNames = [
    'byte',
    'case',
    'char',
    'do',
    'else',
    'enum',
    'eval',
    'for',
    'goto',
    'if',
    'in',
    'int',
    'let',
    'long',
    'new',
    'null',
    'this',
    'true',
    'try',
    'var',
    'void',
    'with',
    'Array',
    'Attr',
    'Audio',
    'Blob',
    'Cache',
    'Date',
    'Error',
    'Event',
    'Feed',
    'File',
    'Hz',
    'Image',
    'Intl',
    'Lock',
    'Map',
    'Math',
    'Node',
    'Proxy',
    'Range',
    'Rect',
    'Set',
    'Table',
    'Text',
    'Touch'
];
